export default __webpack_public_path__ + "static/media/Customer Import Template.54b34e6f.csv";